import { getLogger } from '../../utils/core';

const log = getLogger('flux/bump/bumpInterface');

export type BumpSocketEvent = Event & {
  code?: number;
  reason?: string;
};

export type BumpMessageEvent = Event & {
  data: unknown;
};

export interface BumpInterface {
  create: () => WebSocket | undefined;
  open: (context: string) => void;
  onOpen: (event: Event) => void;
  send: (message: string) => void;
  onMessage: (event: BumpMessageEvent) => void;
  onError: (event: BumpSocketEvent) => void;
  close: (code: number, context: string) => void;
  onClose: (event: BumpSocketEvent) => void;
  isOffline: () => boolean | undefined;
  reconnectTimeout: () => number | boolean | undefined;
  reAuth: () => void;
  checkSocketConnection: () => void;
}

let createInterface: BumpInterface['create'] = () => {
  log.error('initialize createInterface with bumpInterfaceInit first...');
  return undefined;
};
let openInterface: BumpInterface['open'] = () => log.error('initialize openInterface with bumpInterfaceInit first...');
let onOpenInterface: BumpInterface['onOpen'] = () =>
  log.error('initialize onOpenInterface with bumpInterfaceInit first...');
let sendInterface: BumpInterface['send'] = () => log.error('initialize sendInterface with bumpInterfaceInit first...');
let onMessageInterface: BumpInterface['onMessage'] = () =>
  log.error('initialize onMessageInterface with bumpInterfaceInit first...');
let onErrorInterface: BumpInterface['onError'] = () =>
  log.error('initialize onErrorInterface with bumpInterfaceInit first...');
let closeInterface: BumpInterface['close'] = () =>
  log.error('initialize closeInterface with bumpInterfaceInit first...');
let onCloseInterface: BumpInterface['onClose'] = () =>
  log.error('initialize onCloseInterface with bumpInterfaceInit first...');
let isOfflineInterface: BumpInterface['isOffline'] = () => {
  log.error('initialize isOfflineInterface with bumpInterfaceInit first...');
  return undefined;
};
let reconnectTimeoutInterface: BumpInterface['reconnectTimeout'] = () => {
  log.error('initialize reconnectTimeoutInterface with bumpInterfaceInit first...');
  return undefined;
};
let reAuthInterface: BumpInterface['reAuth'] = () =>
  log.error('initialize reAuthInterface with bumpInterfaceInit first...');
let checkSocketConnectionInterface: BumpInterface['checkSocketConnection'] = () =>
  log.error('initialize checkSocketConnectionInterface with bumpInterfaceInit first...');

export const bumpInterfaceInit = ({
  open,
  create,
  onOpen,
  send,
  onMessage,
  onError,
  close,
  onClose,
  isOffline,
  reconnectTimeout,
  reAuth,
  checkSocketConnection,
}: Partial<BumpInterface>): void => {
  createInterface = create || createInterface;
  openInterface = open || openInterface;
  onOpenInterface = onOpen || onOpenInterface;
  sendInterface = send || sendInterface;
  onMessageInterface = onMessage || onMessageInterface;
  onErrorInterface = onError || onErrorInterface;
  closeInterface = close || closeInterface;
  onCloseInterface = onClose || onCloseInterface;
  isOfflineInterface = isOffline || isOfflineInterface;
  reconnectTimeoutInterface = reconnectTimeout || reconnectTimeoutInterface;
  reAuthInterface = reAuth || reAuthInterface;
  checkSocketConnectionInterface = checkSocketConnection || checkSocketConnectionInterface;
};

export const create: BumpInterface['create'] = () => createInterface();
export const open: BumpInterface['open'] = (context) => openInterface(context);
export const onOpen: BumpInterface['onOpen'] = (event) => onOpenInterface(event);
export const send: BumpInterface['send'] = (message) => sendInterface(message);
export const onMessage: BumpInterface['onMessage'] = (event) => onMessageInterface(event);
export const onError: BumpInterface['onError'] = (event) => onErrorInterface(event);
export const close: BumpInterface['close'] = (code, context) => closeInterface(code, context);
export const onClose: BumpInterface['onClose'] = (event) => onCloseInterface(event);
export const isOffline: BumpInterface['isOffline'] = () => isOfflineInterface();
export const reconnectTimeout: BumpInterface['reconnectTimeout'] = () => reconnectTimeoutInterface();
export const reAuth: BumpInterface['reAuth'] = () => reAuthInterface();
export const checkSocketConnection: BumpInterface['checkSocketConnection'] = () => checkSocketConnectionInterface();
